import DatePicker from '../date-picker/DatePicker';
import TimeSelectComponent from '../time-select/TimeSelect';
import { Box, styled } from '@mui/material';

export const DateSelectContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 25px;
`;

export const DateTimeGridContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const DateTimeRow = styled(Box)`
  display: flex;
  gap: 25px;

  @media (max-width: 786px) {
    gap: 15px;
  }
`;

export const DatePickerContainer = styled(Box)`
  width: 100%;
  .MuiStack-root {
    padding: 0;
  }
  .MuiFormControl-root {
    width: 100%;
  }
`;

export const TimePickerContainer = styled(Box)`
  width: 100%;
  min-width: 0;
  .MuiStack-root {
    padding: 0;
  }
  .MuiFormControl-root {
    width: 100%;
  }
`;

export const StyledDatePicker = styled(DatePicker)``;

export const TimeSelect = styled(TimeSelectComponent)``;
